import { Radar, ShieldCheck, Lock, BadgeCheck } from "lucide-react";
import { ThemeToggle } from "@/components/common";

const Point = ({ icon: Icon, title, text }) => (
  <div className="flex gap-3">
    <div className="h-9 w-9 rounded-lg bg-white/10 flex items-center justify-center shrink-0"><Icon className="h-4 w-4" /></div>
    <div><p className="font-semibold text-sm">{title}</p><p className="text-sm text-white/70">{text}</p></div>
  </div>
);

export default function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr]">
      <div className="hidden lg:flex relative flex-col justify-between p-12 bg-[#0B1220] text-white overflow-hidden">
        <div className="absolute inset-0 opacity-[0.15] grid-bg" />
        <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-blue-600/30 blur-3xl" />
        <div className="relative flex items-center gap-2.5">
          <div className="h-9 w-9 rounded-lg bg-blue-600 flex items-center justify-center"><Radar className="h-5 w-5" /></div>
          <span className="font-display font-extrabold text-xl tracking-tight">LeadVault</span>
        </div>
        <div className="relative max-w-md">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-blue-300 mb-4">Verified B2B leads</p>
          <h2 className="font-display text-4xl font-extrabold leading-tight tracking-tight">Every lead hand-verified. Every contact protected.</h2>
          <div className="mt-10 space-y-5">
            <Point icon={BadgeCheck} title="Manually verified" text="Each project is reviewed by our team before it's published." />
            <Point icon={Lock} title="Private by default" text="Client contacts stay sealed until you unlock with credits or a plan." />
            <Point icon={ShieldCheck} title="Pay with confidence" text="UPI & bank transfers verified by an admin before activation." />
          </div>
        </div>
        <p className="relative text-xs text-white/50">© {new Date().getFullYear()} LeadVault</p>
      </div>
      <div className="flex flex-col p-6 sm:p-10">
        <div className="flex justify-end"><ThemeToggle /></div>
        <div className="flex-1 flex items-center justify-center">
          <div className="w-full max-w-md fade-up">
            <h1 className="text-3xl font-extrabold tracking-tight">{title}</h1>
            {subtitle && <p className="text-muted-foreground mt-2 text-sm">{subtitle}</p>}
            <div className="mt-8">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
